import {DenyInfo} from './DenyInfoDTO'

export interface MemberDenyAttributeHistoryJSON {
  id: number
  extensionParamList: DenyInfo[]
  applyDate: string
  reporter: string
  comment: string
}

export interface MemberDenyAttributeHistory {
  id: number
  denyInfoList: DenyInfo[]
  applyDate: string
  reporter: string
  comment: string
}

export class MemberDenyAttributeHistoryDTO implements MemberDenyAttributeHistory {

  constructor(
    public id: number,
    public denyInfoList: DenyInfo[],
    public applyDate: string,
    public reporter: string,
    public comment: string,
  ) {
  }

  static fromJSON(jsonObject: MemberDenyAttributeHistoryJSON): MemberDenyAttributeHistoryDTO {
    return new MemberDenyAttributeHistoryDTO(
      jsonObject.id,
      jsonObject.extensionParamList,
      jsonObject.applyDate,
      jsonObject.reporter,
      jsonObject.comment,
    )
  }
}
